/**
 * @generated SignedSource<<ad111684f32cabb41a8564790f4ff647>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type statusGroupHeader_issueTableGrouping$data = {
  readonly displayName: string;
  readonly statusCategory: {
    readonly statusCategoryId: string;
  };
  readonly " $fragmentType": "statusGroupHeader_issueTableGrouping";
};
export type statusGroupHeader_issueTableGrouping$key = {
  readonly " $data"?: statusGroupHeader_issueTableGrouping$data;
  readonly " $fragmentSpreads": FragmentRefs<"statusGroupHeader_issueTableGrouping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "statusGroupHeader_issueTableGrouping",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "JiraStatusCategory",
      "kind": "LinkedField",
      "name": "statusCategory",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "statusCategoryId"
        }
      ]
    }
  ],
  "type": "JiraJqlStatusFieldValue"
};

(node as any).hash = "4f2de6020bb90556ff180cce2814c51d";

export default node;
